import { createAction, props } from '@ngrx/store';

const PREFIX = '[Modal]';

export const modalOpen = createAction(`${PREFIX} Open`, props<{ key: string }>());
export const modalClosing = createAction(`${PREFIX} Closing`, props<{ key: string }>());
export const modalClosed = createAction(`${PREFIX} Closed`, props<{ key: string }>());
